const state = {// 状态，相当于.vue文件中的data{}
    // language: localStorage.getItem("lang"),
    // thirdShow:false,
    // details:true,
    // LogindialogVisible:false,
    scroll:0,
    serialNumber:''
}

const mutations = {// 同步函数，相当于methods中的方法，方法是同步的
    loginShow(state, data) {
      state.scroll = 0;
      state.scroll = data
    },
    
}

const actions = {// 异步执行函数，相当于methods中的方法，但是方法事异步的

}


export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js